import type { CategoryRef } from '../../shared/api';

/** Read-only category labels, e.g. on collection tiles. */
export function CategoryChips({ categories, max = 3 }: { categories: readonly CategoryRef[]; max?: number }) {
  if (categories.length === 0) return null;
  const shown = categories.slice(0, max);
  const hidden = categories.length - shown.length;
  return (
    <ul className="category-chips" aria-label="Categories">
      {shown.map((category) => (
        <li key={category.id}>{category.name}</li>
      ))}
      {hidden > 0 && <li className="category-chips__more">+{hidden}</li>}
    </ul>
  );
}
